import AOS from 'aos';
import 'aos/dist/aos.css';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';
import SliderCarousel from './SliderCarousel';

import about1 from '../../images/homescreen/about1.jpg';
import bar1 from '../../images/homescreen/bar1.jpg';
import conference from '../../images/homescreen/conference.jpg';
import img1 from '../../images/homescreen/img-1.png';
import img2 from '../../images/homescreen/img-2.png';
import img3 from '../../images/homescreen/img-3.png';
import wedding from '../../images/homescreen/wedding.jpg';


AOS.init({
    duration: '1000'
});

const HomeScreen  = () => {
  return (
    <>
    <Carousel style={{ "maxHeight": "500px" }}>
        <Carousel.Item>
        <img
            className="d-block w-100"
            src={img1}
            alt="First slide"
        />
        <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
        <img
            className="d-block w-100"
            src={img2}
            alt="Second slide"
        />
        <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
        <img
            className="d-block w-100"
            src={img3}
            alt="Third slide"
        />
        <Carousel.Caption>
            <h3>Third slide label</h3>
            <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
        </Carousel.Caption>
        </Carousel.Item>
    </Carousel>

    <section className='container'>
        <h3> <i className='fa fa-duotone fa-circle-info' /> &nbsp; About</h3>
        <div className="row" style={{ width: "100%", marginTop:"40px"}}>
            <div className="col">
                <ul>
                    <li style={{ textAlign: "justify", textJustify:"inter-word" }}>
                        A personal tropical sanctuary that is perfect for escaping the city,
                        Shangri-La Colombo overlooks the Indian Ocean in the heart of the
                        business district with direct access to the most extensive international
                        shopping mall in India. The hotel offers the finest accommodation in India,
                        an exciting new dining and social scene and the largest and extensive hotel
                        conference and event facilities.
                    </li>
                    <li style={{ textAlign: "justify", textJustify:"inter-word" }}>
                        <ul style={{ listStyle: "square", marginTop: "20px"}}>
                            <li style={{marginTop: "20px"}}>69 rooms and suites</li>
                            <li style={{marginTop: "20px"}}>Unrivalled shopping experience in India's leading Mall Hotel</li>
                            <li style={{marginTop: "20px"}}>GharBar Cares: Our commitment to your well-being</li>
                        </ul>
                    </li>
                    <li style={{marginTop: "40px"}}><button className='btn btn-outline-warning'>Learn More</button></li>
                </ul>
            </div>
            <div className="col">
                <ul style={{ "justifyContent": "right"}}>
                    <li><img src={about1} data-aos='fade-left' alt="about" style={{maxHeight:"500px", maxWidth: "500px", height: "auto", width: "auto", float: "right"}}></img> </li>
                </ul>
            </div>
        </div>

        <hr/>

        <h3> <i className='fa fa-duotone fa-wine-bottle' /> &nbsp; Drinks & Bars</h3>
        <div className="row" style={{ width: "100%", marginTop:"40px"}}>
            <div className="col">
                <ul style={{ "justifyContent": "right"}}>
                    <li><img src={bar1} data-aos='fade-right' alt="about" style={{maxHeight:"500px", maxWidth: "500px", height: "auto", width: "auto", float: "right"}}></img> </li>
                </ul>
            </div>
            <div className="col">
                <ul>
                    <li style={{ textAlign: "justify", textJustify:"inter-word" }}>
                        A personal tropical sanctuary that is perfect for escaping the city,
                        Shangri-La Colombo overlooks the Indian Ocean in the heart of the
                        business district with direct access to the most extensive international
                        shopping mall in India. The hotel offers the finest accommodation in India,
                        an exciting new dining and social scene and the largest and extensive hotel
                        conference and event facilities.
                    </li>
                    <li style={{ textAlign: "justify", textJustify:"inter-word" }}>
                        <ul style={{ listStyle: "square", marginTop: "20px"}}>
                            <li style={{marginTop: "20px"}}>69 rooms and suites</li>
                            <li style={{marginTop: "20px"}}>Unrivalled shopping experience in India's leading Mall Hotel</li>
                            <li style={{marginTop: "20px"}}>GharBar Cares: Our commitment to your well-being</li>
                        </ul>
                    </li>
                    <li style={{marginTop: "40px"}}><button className='btn btn-outline-warning'>Learn More</button></li>
                </ul>
            </div>
        </div>

        <hr />

        <h3><i className='fa fa-duotone fa-bed' /> &nbsp; Recommended room types</h3>
        <p>Offering striking views of the Indian Ocean, Beira Lake and the city beyond, our 500 guest rooms and suites, and 41 serviced apartments are tastefully furnished to complement the urban-oceanside location and are among the largest in India.</p>
        <div style={{ marginTop:"40px"}} data-aos='zoom-in'>
            <SliderCarousel/>
        </div>

        <hr/>

        <h3><i className='fa fa-duotone fa-calendar-days' /> &nbsp; Unforgettable Events</h3>
        <p>Design and enhance your event experiences with the very best of GharBar</p>
        <div className="row" style={{ width: "100%", marginTop:"40px"}}>
            <div className="col">
                <Card style={{ width: '100%' }} data-aos='fade-right'>
                    <Card.Img variant="top" src={conference} />
                    <Card.Body>
                        <Card.Title>Conference & Meetings</Card.Title>
                        <Card.Text>
                        Some quick example text to build on the card title and make up the
                        bulk of the card's content.
                        </Card.Text>
                        <button className='btn btn-outline-warning'>Learn More</button>
                    </Card.Body>
                </Card>
            </div>
            <div className="col">
                <Card style={{ width: '100%'}} data-aos='fade-left'>
                    <Card.Img variant="top" src={wedding} />
                    <Card.Body>
                        <Card.Title>Wedding Planning</Card.Title>
                        <Card.Text>
                        Some quick example text to build on the card title and make up the
                        bulk of the card's content.
                        </Card.Text>
                        <button className='btn btn-outline-warning'>Learn More</button>
                    </Card.Body>
                </Card>
            </div>
        </div>

        <hr/>

        <h3><i className='fa fa-duotone fa-percent' /> &nbsp; Offers</h3>
        <p>Get most savings with these exciting GharBar offers.</p>
        <div className="row" style={{ width: "100%", marginTop:"40px"}}>
            <div className="col">
                <Card style={{ width: '100%' }} data-aos='zoom-in-left'>
                    <Card.Img variant="top" src={conference} />
                    <Card.Body>
                        <Card.Title>Rooms & Suites</Card.Title>
                        <Card.Text>
                        Discount on room booking for 4+ nights.
                        </Card.Text>
                        <button className='btn btn-outline-warning'>Learn More</button>
                    </Card.Body>
                </Card>
            </div>
            <div className="col">
                <Card style={{ width: '100%'}} data-aos='zoom-in'>
                    <Card.Img variant="top" src={wedding} />
                    <Card.Body>
                        <Card.Title>Bars</Card.Title>
                        <Card.Text>
                        Free drinks to 3 lucky draw customers.
                        </Card.Text>
                        <button className='btn btn-outline-warning'>Learn More</button>
                    </Card.Body>
                </Card>
            </div>
            <div className="col">
                <Card style={{ width: '100%'}} data-aos='zoom-in-right'>
                    <Card.Img variant="top" src={wedding} />
                    <Card.Body>
                        <Card.Title>Events</Card.Title>
                        <Card.Text>
                        Early booking discount upto 10%
                        </Card.Text>
                        <button className='btn btn-outline-warning'>Learn More</button>
                    </Card.Body>
                </Card>
            </div>
        </div>
    </section>
    </>
  )
};

export default HomeScreen;